"use client";
import { PrismicNextLink } from "@prismicio/next";
import React from "react";

const ctaStyles = {
  yellow: "bg-yellow text-dark-green  border-transparent",
  outline: "bg-transparent text-gray border-gray ",
  "outline-green": "bg-transparent text-dark-green border-dark-green ",
};

export default function Cta({
  page,
  padding,
  width,
  variant,
  toggleVariant,
  isToggled
}) {
  return (
    <PrismicNextLink
      field={page}
      onMouseEnter={() => {
        toggleVariant(!isToggled)
      }}
      className={
        `cta-text rounded-lg cursor-pointer py-2.5 border no-underline
        ${padding} ${width} text-center transition 
        ${ctaStyles[variant]}`
      }
    />

  );
}
